import '../../styles/Nosotros/nosotrosCover.scss';
import nosotrosCover  from '../../assets/nosotros-cover.svg';

export const NosotrosCover = () => {
    return (
        <div className="nosotros-cover">
            <div className="nosotros-cover-container">
                <div className='nosotros-cover-text'>
                    <h2 data-aos="fade-right" data-aos-delay="400">Quienes somos?</h2>
                    <p data-aos="fade-right" data-aos-delay="600">
                    Somos líderes en la búsqueda y selección de talentos IT para toda LATAM.<br />
                    Desde nuestra fundación en 2015, nos hemos dedicado a conectar a los <span style={{ color: '#049969', fontWeight: '600' }}>mejores perfiles</span> con las empresas que buscan impulsar la <span style={{ color: '#049969', fontWeight: '600' }}>innovación</span> y el <span style={{ color: '#049969', fontWeight: '600' }}>crecimiento</span> en la región.
                    </p>
                </div>
                <div data-aos="zoom-out" data-aos-offset="0" className='nosotros-cover-image'>
                <img src={nosotrosCover} alt="cover image" />
                </div>
            </div>
        </div>
    )
}
export default NosotrosCover;